<div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 class="ml-20">{{'DETALLES.TITULO' | translate}}</h2>
  <button mat-icon-button (click)="cerrar()">
    <mat-icon class="s-20">close</mat-icon>
  </button>
</div>
<mat-list>
  <mat-list-item>
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon mat-list-icon>star</mat-icon>
        <p mat-line><b>{{'DETALLES.PRODUCTO' | translate}}</b></p>
      </div>
      <p mat-line class="mt-0"><em>{{'CONSULTATABLA.PRODUCTOS.' + datosDetallesProducto.producto | translate}} {{datosDetallesProducto.anio}}</em></p>
    </div>
  </mat-list-item>
  <mat-list-item>
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon mat-list-icon>vpn_key</mat-icon>
        <p mat-line><b>{{'DETALLES.SURVEYTOKEN' | translate}}</b></p>
      </div>
      <p mat-line class="mt-0"><em>{{datosDetallesProducto.surveyToken}}</em></p>
    </div>
  </mat-list-item>
  <ng-container *ngFor="let fecha of datosDetallesProducto.fechasProducto">
  <mat-list-item *ngIf="fecha.activa">
    <div fxLayout="column" fxLayoutAlign="start stretch">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon mat-list-icon>event</mat-icon>
        <p mat-line><b>{{'DETALLES.FECHAS.' + fecha.tipo | translate}}: </b></p>
      </div>
      <p mat-line class="mt-0"><em>{{fecha.fecha | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fecha |date:'O' : offsetPipe : idiomaActual}})</em> </p>
    </div>
  </mat-list-item>
  </ng-container>
  <ng-container *ngIf="mostrarRecord">
    <mat-accordion class="example-headers-align" multi>
      <mat-expansion-panel class="mat-elevation-z0 margen">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div fxLayout="row" fxLayoutAlign="start start">
              <span class="material-icons-outlined">event_note</span>
              <b>{{'DETALLES.FECHAS.recordatorio'| translate}}: </b>
            </div>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-list role="list"  class="mt">
          <mat-list-item role="listitem" *ngFor="let fecha of datosDetallesProducto.recordatorios">
            <div fxLayout="row" fxLayoutAlign="start start">
              <span class="material-icons-outlined">arrow_right</span>
              <em>{{fecha.fechaRecordatorio | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fechaRecordatorio |date:'O' : offsetPipe : idiomaActual}})</em>
            </div>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
  <ng-container *ngIf="mostrarAvi">
    <mat-accordion class="example-headers-align" multi>
      <mat-expansion-panel class="mat-elevation-z0 margen">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div fxLayout="row" fxLayoutAlign="start start">
              <span class="material-icons-outlined">event_note</span>
              <b>{{'DETALLES.FECHAS.avisos'| translate}}: </b>
            </div>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-list role="list"  class="mt">
          <mat-list-item role="listitem" *ngFor="let fecha of datosDetallesProducto.avisos">
            <div fxLayout="row" fxLayoutAlign="start start">
              <span class="material-icons-outlined">arrow_right</span>
              <em *ngIf="datosDetallesProducto.producto!=63">{{fecha.aviso | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.aviso |date:'O' : offsetPipe : idiomaActual}})</em>
              <em *ngIf="datosDetallesProducto.producto==63">{{fecha.fechaRecordatorio | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fechaRecordatorio |date:'O' : offsetPipe : idiomaActual}})</em>
            </div>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>

  <mat-divider [inset]="true"></mat-divider>
  <h3 mat-subheader>{{'DETALLES.PROGRESO' | translate}}</h3>
  <mat-list-item>
    <div fxLayout="row wrap" class="w100" *ngIf="datosDetallesProducto.producto != 3">
      <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
        <h3 class="m-0">{{'DETALLES.AVANCES.NORMAL' | translate}}<b>{{datosDetallesProducto.progreso.porcentaje | number :'1.0-2'}}%</b></h3>
      </div>
      <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progreso.porcentaje" class="barraAvance" fxFlex="100"></mat-progress-bar>
    </div>
    <div fxLayout="column" fxLayoutAlign="start stretch" class="w100" *ngIf="datosDetallesProducto.producto == 3">
      <div fxLayout="row wrap">
        <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
          <h3 class="m-0">{{'DETALLES.AVANCES.MAS50' | translate}}<b>{{datosDetallesProducto.progresoNom35.mas50.porcentaje | number :'1.0-2'}}%</b></h3>
        </div>
        <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.mas50.porcentaje" class="barraAvance" fxFlex="100"></mat-progress-bar>
      </div>
      <div fxLayout="row wrap" class="mt-20">
        <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
          <h3 class="m-0">{{'DETALLES.AVANCES.MENOS50' | translate}}<b>{{datosDetallesProducto.progresoNom35.menos50.porcentaje | number :'1.0-2'}}%</b></h3>
        </div>
        <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.menos50.porcentaje" class="barraAvance" fxFlex="100"></mat-progress-bar>
      </div>
    </div>
  </mat-list-item>
  <h3 mat-subheader>{{'DETALLES.RESTANTE' | translate}}</h3>
  <mat-list-item>
    <div fxLayout="row wrap" class="w100">
      <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
        <h3 class="m-0">{{'DETALLES.DIASREST' | translate}}<b>{{datosDetallesProducto.diasRestantes}} / {{diasTotales}}</b></h3>
      </div>
      <mat-progress-bar mode="buffer" [value]="porcentajeDias" class="barraAvance" fxFlex="100"></mat-progress-bar>
    </div>
  </mat-list-item>
</mat-list>
<div class="w100 mt-20" fxLayout="row" fxLayoutAlign="center">
  <button mat-raised-button (click)="fijar()">{{'DETALLES.PANELFIJO' |  translate}}</button>
</div>
